module.exports = __webpack_public_path__ + "img/ferramentas-icon.b3f449f6.png";